<template>
  <div style="z-index: 15060;background-color: white;height: 800px">
    <div class="row centered">
      <img src="@/assets/logo.png" style="width: 100%"/>
    </div>
    <div class="row">
    </div>
  </div>
</template>

<script>
export default {
  name: "CookLogo"
}
</script>

<style scoped>
.centered {
  position: fixed;
  top: 40%;
  left: 20%;
  transform: translate(-14%, -10%);
}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/CookLogo.vue